var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-input',{ref:"fileInput",attrs:{"color":_vm.color,"icon":_vm.icon,"accept":_vm.accept,"multiple":false,"disabled":_vm.disabled,"tip":_vm.$t('Добавить файл')},on:{"change":_vm.changeFiles}})}
var staticRenderFns = []

export { render, staticRenderFns }